import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({ children, className = "" }) {
  return (
    <div className={`text-sm text-slate-600 leading-relaxed space-y-2 ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h1 className="font-display text-lg font-semibold text-slate-900 mt-4 mb-1" {...p} />,
          h2: (p) => <h2 className="font-display text-base font-semibold text-slate-800 mt-3 mb-1" {...p} />,
          h3: (p) => <h3 className="font-medium text-slate-800 mt-2" {...p} />,
          p: (p) => <p className="leading-relaxed" {...p} />,
          ul: (p) => <ul className="list-disc pl-5 space-y-1" {...p} />,
          ol: (p) => <ol className="list-decimal pl-5 space-y-1" {...p} />,
          li: (p) => <li className="leading-relaxed" {...p} />,
          strong: (p) => <strong className="font-semibold text-slate-900" {...p} />,
          code: (p) => <code className="font-mono text-[0.85em] bg-slate-100 rounded px-1 py-0.5" {...p} />,
          hr: () => <hr className="border-slate-200 my-3" />,
          a: (p) => <a className="text-blue-700 underline" {...p} />,
          table: (p) => <div className="overflow-x-auto my-2"><table className="w-full text-sm border-collapse" {...p} /></div>,
          thead: (p) => <thead className="bg-slate-50" {...p} />,
          th: (p) => <th className="border border-slate-200 px-2 py-1 text-left font-semibold text-slate-700" {...p} />,
          td: (p) => <td className="border border-slate-200 px-2 py-1 align-top" {...p} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
